import React from "react";
import KoIcon from "@kwapio/icons";
import styles from "./status.module.scss";

function CaseTypeStatus({ data, bool }) {
  let finalStatus = "";

  switch (data) {
  case 'positive':
    finalStatus = "Positive";
    break;

  case 'negative':
    finalStatus = "Negative";
    break;

  default:
    finalStatus = "Positive";
    break;
  }

  return bool ? (
    <div className={styles.wrapper}>
      {finalStatus === "Positive" ? (
        <KoIcon name="TickFilled" />
      ) : (
        <KoIcon name="CrossFilled" />
      )}
    </div>
  ) : (
    <div className={styles.wrapper}>
      <div
        className={`${styles.status} ${
          styles[finalStatus.replaceAll(" ", "")]
        }`}
      >
        <div className={styles.text}>{finalStatus}</div>
      </div>
    </div>
  );
}

export default CaseTypeStatus;
